import { useEffect, useRef } from "react";
import Plotly from "plotly.js-dist-min";
import { RACE_COLORS, FONT_FAMILY, IS_TOUCH } from "../constants.js";

export default function TimeSeries({ data }) {
  const ref = useRef();

  useEffect(() => {
    if (!data || !data.length) return;

    const dates = data.map(d => d.date + "-01"); // convert YYYY-MM to date string

    const totalVals  = data.map(d => d.total);
    const blackVals  = data.map(d => d.black);
    const whiteVals  = data.map(d => d.white);

    const hasBlack = blackVals.some(v => v > 0);
    const hasWhite = whiteVals.some(v => v > 0);

    const traces = [
      {
        type: "scatter",
        mode: "lines+markers",
        name: "TOTAL",
        x: dates,
        y: totalVals,
        line: { color: "#4C78A8", width: 2.5 },
        marker: { size: 4, color: "#4C78A8" },
        hovertemplate: "<b>TOTAL</b><br>%{x|%b %Y}: %{y}<extra></extra>",
      },
      ...(hasBlack ? [{
        type: "scatter",
        mode: "lines+markers",
        name: "BLACK",
        x: dates,
        y: blackVals,
        line: { color: RACE_COLORS.BLACK, width: 2 },
        marker: { size: 4, color: RACE_COLORS.BLACK },
        hovertemplate: "<b>BLACK</b><br>%{x|%b %Y}: %{y}<extra></extra>",
      }] : []),
      ...(hasWhite ? [{
        type: "scatter",
        mode: "lines+markers",
        name: "WHITE",
        x: dates,
        y: whiteVals,
        line: { color: RACE_COLORS.WHITE, width: 2 },
        marker: { size: 4, color: RACE_COLORS.WHITE },
        hovertemplate: "<b>WHITE</b><br>%{x|%b %Y}: %{y}<extra></extra>",
      }] : []),
    ];

    Plotly.react(ref.current, traces, {
      title: {
        text: "<b>Stops Over Time</b>",
        font: { size: 18, color: "#333333", family: FONT_FAMILY },
        x: 0, xanchor: "left",
      },
      height: 400,
      margin: { l: 70, r: 40, t: 80, b: 110 },
      xaxis: {
        title: "Year",
        type: "date",
        tickformat: "%Y",
        tickfont: { size: 13, family: FONT_FAMILY },
        showgrid: true,
        gridcolor: "#e8e8e8",
      },
      yaxis: {
        title: "Number of stops",
        tickfont: { size: 13, family: FONT_FAMILY },
        showgrid: true,
        gridcolor: "#e8e8e8",
        rangemode: "tozero",
      },
      legend: {
        orientation: "h",
        x: 0,
        y: -0.28,
        font: { family: FONT_FAMILY },
      },
      font: { family: FONT_FAMILY },
      paper_bgcolor: "white",
      plot_bgcolor: "white",
      showlegend: true,
      hovermode: "x unified",
    }, { responsive: true, displayModeBar: false, staticPlot: IS_TOUCH });
  }, [data]);

  if (!data || !data.length) return null;
  if (data.every(d => d.total === 0)) return null;
  return (
    <div className="chart-scroll-x">
      <div ref={ref} style={{ minWidth: 560 }} />
    </div>
  );
}
